import React from 'react';

interface ArenaQuestionPeekButtonProps {
  onShowQuestion: () => void;
}

const QUESTION_TOGGLE_TOP = 'max(12px, calc(env(safe-area-inset-top, 0px) + 0.5rem))';

const ArenaQuestionPeekButton: React.FC<ArenaQuestionPeekButtonProps> = ({
  onShowQuestion,
}) => {
  const questionToggleStyle: React.CSSProperties = {
    position: 'fixed',
    top: QUESTION_TOGGLE_TOP,
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 1001,
    minWidth: 'clamp(150px, 40vw, 200px)',
    padding: '0.7rem 1rem',
    borderRadius: '16px',
    border: '2px solid rgba(255,255,255,0.26)',
    background:
      'linear-gradient(180deg, rgba(10,25,47,0.88) 0%, rgba(20,50,86,0.88) 100%)',
    color: '#F8FAFC',
    backdropFilter: 'blur(8px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.35rem',
    boxShadow: '0 10px 28px rgba(0,0,0,0.3)',
    touchAction: 'manipulation',
    fontSize: '1.02rem',
    fontWeight: 800,
    cursor: 'pointer',
    userSelect: 'none',
    WebkitUserSelect: 'none',
  };

  return (
    <button
      type="button"
      aria-label="Show question"
      onPointerDown={(event) => {
        event.stopPropagation();
      }}
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
        onShowQuestion();
      }}
      style={questionToggleStyle}
    >
      <span style={{ fontSize: '1.2rem' }}>?</span>
      <span>Tab to show Q</span>
    </button>
  );
};

export default ArenaQuestionPeekButton;
